export default {"src":"/_next/static/media/strategic_insights_data_driven_planning.edc1b680.svg","height":31,"width":31,"blurWidth":0,"blurHeight":0};